var map = {
	"./characters.mp4": "beb9",
	"./dancees.mp4": "9fac",
	"./danceing.mp4": "eb3e",
	"./danceit.mp4": "e429",
	"./dancept.mp4": "874c",
	"./melodiaes.mp4": "e7bd",
	"./melodiaing.mp4": "8eb6",
	"./melodiait.mp4": "5955",
	"./melodiapt.mp4": "22c4",
	"./ritmoes.mp4": "09c6",
	"./ritmoing.mp4": "76f9",
	"./ritmoit.mp4": "3fff",
	"./ritmopt.mp4": "1fbd",
	"./singes.mp4": "8750",
	"./singing.mp4": "4e87",
	"./singit.mp4": "9c6d",
	"./singpt.mp4": "a1ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1189";